import { action } from 'satcheljs';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { OwaDate } from 'owa-datetime';
import { FullComposeEntrySourceType } from 'owa-calendar-helpers-types';

export const dropMailItem = action(
    'dropMailItem',
    (
        dragData: MailListRowDragData,
        entryType: FullComposeEntrySourceType,
        preFillStartTime?: OwaDate
    ) => ({
        dragData,
        entryType,
        preFillStartTime,
    })
);
